import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
  providedIn: 'root'
  
})
export class JobcostingService {

  // private apiURL = "http://inspectmite.net/";
  constructor(private http: HttpClient) { }
  
  /** POST: add a new hero to the database */
  getJobCost (data): Observable<any> {
    return this.http.post<any>(environment.api+'jobcost', data, httpOptions)
      .pipe(
        map(res=>res)
      );
  }
  

}
